import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7c651817"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "test-view-page__header"
}
const _hoisted_2 = { class: "test-view-page__category" }
const _hoisted_3 = { class: "test-view-page content-container" }
const _hoisted_4 = { class: "test-view-page__meta" }
const _hoisted_5 = { class: "test-view-page__meta-item" }
const _hoisted_6 = { class: "test-view-page__meta-item" }
const _hoisted_7 = { class: "test-view-page__title" }
const _hoisted_8 = { class: "test-view-page__description" }
const _hoisted_9 = { class: "test-view-page__benefits" }
const _hoisted_10 = { class: "test-view-page__benefits-title" }
const _hoisted_11 = {
  key: 0,
  class: "test-view-page__related-courses"
}
const _hoisted_12 = { class: "test-view-page__related-courses-title" }
const _hoisted_13 = { class: "test-view-page__related-courses-list" }
const _hoisted_14 = { class: "test-view-page__disclaimer" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = {
  key: 1,
  class: "spinner"
}

import {
  IonContent,
  IonPage,
  IonIcon,
  IonSpinner,
  onIonViewWillEnter,
} from '@ionic/vue';

import { alarm, book, shareSocial } from 'ionicons/icons';
import { computed, reactive } from 'vue';
import { CourseI, TestItemI, ThemeI } from '@/types';
import { useRoute, useRouter } from 'vue-router';
import api from '@/api';
import { useInternalization } from '@/composables/useInternalization';

import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/grid';
import { Grid } from 'swiper/modules';

import CourseItem from '@/components/CourseItem.vue';
import TheHeader from '@/components/TheHeader.vue';
import BaseButton from '@/components/BaseButton.vue';
import ShareModal from '@/components/modals/ShareModal.vue';
import { logEvent } from '@/services/analytics';


export default /*#__PURE__*/_defineComponent({
  __name: 'TestViewPage',
  setup(__props) {

const state = reactive<{
  test: TestItemI | null;
  theme: ThemeI | null;
  relatedCourses: CourseI[];
  isShareModalOpened: boolean;
}>({
  test: null,
  theme: null,
  relatedCourses: [],
  isShareModalOpened: false,
});

const route = useRoute();
const router = useRouter();
const { t, locale } = useInternalization();

const testId = computed(() => {
  return route.params.id as string;
});
const themeName = computed(() => {
  return (
    state.theme?.translations[locale.value]?.name || state.theme?.name || ''
  );
});
const cssImagePath = computed(() => {
  if (state.test) {
    return 'url("' + state.test.imgPath + '")';
  }
  return '';
});

const handleShare = () => {
  if (!state.test) {
    return;
  }
  state.isShareModalOpened = true;
};

const handleGetStartedClick = async () => {
  logEvent('test_click_get_started');

  if (state.test) {
    router.push({
      name: 'TestInProgress',
      params: {
        id: state.test.id,
      },
    });
  }
};

const getTest = async () => {
  state.test = await api.tests.getById(testId.value);
};
const getThemeById = async (id: string) => {
  state.theme = await api.themes.getById(id);
};
const getRelatedCourses = async () => {
  if (!state.test?.relatedCourseIds) {
    return;
  }

  state.relatedCourses = [];

  await Promise.all(
    state.test.relatedCourseIds.map(async (id) => {
      const course = await api.courses.getById(id);
      if (course) {
        state.relatedCourses.push(course);
      }
    })
  );
};

const handleCourseClick = (course: CourseI) => {
  router.push({ name: 'TherapyCourse', params: { id: course.id } });
};

onIonViewWillEnter(async () => {
  await getTest();
  if (state.test) {
    await getThemeById(state.test.categoryId);
  }
  await getRelatedCourses();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(TheHeader, {
            title: _unref(t)('test'),
            "show-avatar": false
          }, null, 8, ["title"]),
          _createElementVNode("div", {
            class: "test-view-page__share-btn",
            onClick: handleShare
          }, [
            _createVNode(_unref(IonIcon), { icon: _unref(shareSocial) }, null, 8, ["icon"])
          ]),
          (state.test)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                  class: "test-view-page__img-container",
                  style: _normalizeStyle({ backgroundImage: cssImagePath.value })
                }, [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(themeName.value), 1)
                ], 4)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            (state.test)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_unref(IonIcon), { icon: _unref(alarm) }, null, 8, ["icon"]),
                      _createElementVNode("div", null, _toDisplayString(state.test.approxTime), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_unref(IonIcon), { icon: _unref(book) }, null, 8, ["icon"]),
                      _createElementVNode("div", null, _toDisplayString(_unref(t)('questionsCount', { n: state.test.questions.length })), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(state.test.title), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(state.test.description), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('testBenefitsTitle')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.test.benefits, (benefit, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "test-view-page__benefits-item",
                        key: i
                      }, _toDisplayString(benefit), 1))
                    }), 128))
                  ]),
                  (state.relatedCourses.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('relatedCourses')), 1),
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_unref(Swiper), {
                            class: "tests-bar",
                            "slides-per-view": 1.8,
                            grid: {
                  rows: 1,
                  fill: 'row',
                },
                            "space-between": 10,
                            modules: [_unref(Grid)]
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.relatedCourses, (course) => {
                                return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                                  key: course.id,
                                  class: "tests-bar__item clickable"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(CourseItem, {
                                      course: course,
                                      mini: "",
                                      onClick: ($event: any) => (handleCourseClick(course))
                                    }, null, 8, ["course", "onClick"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modules"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('disclaimer')) + ": ", 1),
                    _createElementVNode("div", {
                      style: {"display":"inline"},
                      innerHTML: _unref(t)('testDisclaimer')
                    }, null, 8, _hoisted_15)
                  ]),
                  _hoisted_16,
                  _createVNode(BaseButton, {
                    class: "test-view-page__btn",
                    onClick: handleGetStartedClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('getStarted')), 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_unref(IonSpinner))
                ]))
          ]),
          _createVNode(ShareModal, {
            "is-opened": state.isShareModalOpened,
            type: "test",
            test: state.test || undefined,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (state.isShareModalOpened = false))
          }, null, 8, ["is-opened", "test"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})